const name = 'Spin';
const properties = {
    schema: {},
};
const powerMap = {
    soft: { easing: 'linear' },
    medium: { easing: 'quintInOut' },
    hard: { easing: 'backOut' },
};
const directionMap = {
    clockwise: 1,
    'counter-clockwise': -1,
};
/**
 * Spin animation object
 */
function animate(kit, elements, duration, delay, { power, easing = 'linear', direction = 'clockwise', ...params } = {}) {
    const sequence = kit.sequence(params);
    const spinDirection = directionMap[direction];
    const ease = typeof power !== 'undefined' ? powerMap[power].easing : easing;
    sequence
        .add(kit.animate('BaseRotate', elements, duration, 0, {
        to: { rotation: `+=${360 * spinDirection}deg` },
        ease,
    }))
        .add(kit.animate('BaseNone', elements, delay, 0)); // add repeat delay
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=spin.js.map